<template>
  <div v-show="isShow" class="select_site-icas">
    <span class="site_icon">
      <img v-if="isIscoTheme" src="@/assets/login_images/site_black.svg" alt="">
      <img v-else-if="isLogin" src="@/assets/login_images/site.png" alt="">
      <img v-else src="@/assets/common/site.png" alt="">
    </span>
    <el-dropdown v-if="showMemu" class="drop" :class="{'gray':isLogin,'white':!isLogin}" @command="handleSetSite" @visible-change="handleVisibleChange">
      <span class="el-dropdown-link">
        {{ siteConfig.countryName }}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-input v-model="searchContent" class="search-field" size="small" :placeholder="$t('standard.pleaseInput')" @input="handleInput" />
        <el-dropdown-item
          v-for="(item, index) in filteredSiteList"
          :key="index"
          :command="item"
          :disabled="siteConfig.country === item.country"
        >
          {{ item.countryName }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div v-else class="drop">
      {{ siteConfig.countryName }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { replaceParamVal, getUrlKey, isFromTawian } from '@/utils'
import { SF_IUOP } from '@/utils/constant'
export default {
  // 登录页站点切换组件
  name: 'SiteSelectIcon',
  props: {
    showMemu: {
      type: Boolean,
      default: true
    },
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filteredSiteList: [],
      searchContent: '',
      SF_IUOP: SF_IUOP,
      isShow: true
    }
  },
  computed: {
    ...mapGetters(['siteList', 'siteConfig', 'system_source']),
    isIscoTheme() {
      return ['ISCO', 'ISCO-OS', 'SCS-CCS-CORE-US'].includes(this.system_source)
    },
    // isShow() {
    //   // 中国台湾永远隐藏国家组件

    // }
  },
  watch: {
    siteConfig(val) {
      if (localStorage.getItem('isFromTainwan') === '1') {
        this.isShow = false
      } else {
        this.isShow = true
      }
    },
    siteList(val) {
      this.filteredSiteList = val
    }
  },
  created() {
    // cas 登录方案,不走本地缓存
    let siteCountryCode = getUrlKey('siteCountryCode') || ''
    // 缓存发现是台湾地区整个页面按照台湾处理
    // debugger
    if (isFromTawian() === '1') {
      if (siteCountryCode) {
        replaceParamVal('siteCountryCode', siteCountryCode)
      }
      siteCountryCode = 'TW'
    }
    if (this.system_source) {
      this.getSiteCode()
    } else { // todo lzb 这块按理来说是没用了 沟通后是icas本身登录跳转到自身页面的一个处理 比如微信登录不带sysCode会走这里
      // iuop 若本地缓存有站点配置，取本地缓存，否则根据请求接口获取用户所在站点编码再获取相应的站点配置！
      const localSiteConfig = JSON.parse(localStorage.getItem('localSiteConfig') || '{}')
      const localLangCode = localStorage.getItem('localLangCode')
      const lang = getUrlKey('lang')
      if (localSiteConfig && localSiteConfig.country) { // 本地站点配置缓存存在
        const langCode = lang || localLangCode || localSiteConfig.langDefault.lang
        // 台湾过来的

        const country = siteCountryCode || localSiteConfig.country
        // 前端国际化
        this.$i18n.locale = langCode
        // 更新语言
        this.setLanguage(langCode)
        // 更新全量国家区号列表
        this.setMobileCountries({ siteCountryCode: country })
        // 更新站点列表
        this.setSiteList(country)
        // 更新站点配置
        this.setSiteConfig({ country })
        this.getEnabledGeneratorPassword(country)
      } else {
        this.getSiteCode()
      }
    }
    // console.log(111111111, country, this.siteConfig)
    // if (siteCountryCode == 'TW') {
    //   this.isShow = false
    // }
    this.filteredSiteList = this.siteList
    console.log(333333333333444, this.filteredSiteList)
  },
  methods: {
    ...mapActions({
      setLanguage: 'site/setLanguage',
      getSiteCode: 'site/siteCode',
      setSiteConfig: 'site/siteConfig',
      setSiteList: 'site/siteList',
      setMobileCountries: 'public/mobileCountries',
      setAppLoading: 'app/setAppLoading',
      getEnabledGeneratorPassword: 'site/getEnabledGeneratorPassword'
    }),
    handleSetSite(item) {
      this.setAppLoading(true)
      // 站点切换时，默认所在站
      const langDefault = item.langDefault
      this.setLanguage(langDefault.lang)
      this.$i18n.locale = langDefault.lang
      // console.log(11111111, this.siteConfig.country)
      this.setMobileCountries({ siteCountryCode: item.country })
      // 更新站点列表
      // debugger
      this.setSiteList(item.country)
      this.setSiteConfig({ country: item.country })
      // 若url上有sysCode，切换语言同步新增或修改url上的siteCountryCode的值；切换语言同步修改url上的lang的值

      replaceParamVal('siteCountryCode', item.country)
      if (getUrlKey('sysCode')) {
        replaceParamVal('lang', langDefault.lang)
      }
      this.$message({
        message: this.$t('message.switchSite'),
        type: 'success'
      })
      setTimeout(() => {
        window.location.reload()
      }, 1000)
      this.searchContent = ''
      this.filteredSiteList = this.siteList
      this.$track({ sceneType: 'Login', eventType: 'Select_Country', message: item.country })
    },
    handleInput(val) {
      if (!val || !val.trim()) {
        this.filteredSiteList = this.siteList
        return
      }
      this.filteredSiteList = this.siteList.filter(i => i.countryName.toLowerCase().indexOf(val.trim().toLowerCase()) > -1)
      console.log(3333333333335555, this.filteredSiteList)
    },
    handleVisibleChange(visible) {
      if (visible) {
        this.searchContent = ''
        this.filteredSiteList = this.siteList
        console.log(3333333333336666, this.filteredSiteList)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
  .select_site-icas {
    cursor: pointer;
    .site_icon {
      margin-right: 2px;
      >img{
        display: inline-block;
        vertical-align: middle;
        width: 16px;
        height: 16px;
      }
    }
    .drop {
      display: inline-block;
      vertical-align: middle;
    }
    .gray{
      color: $color02;
    }
    .white{
      color: $color01;
    }
  }
  .search-field {
    padding: 3px 20px 8px;
    width: 100%;
  }

</style>
